<template>
  <div id="printable" class="hidenBackground">
    <b-row v-if="loading">
      <b-col cols="12" class="text-center">
        <b-spinner label="Spinning"></b-spinner>
      </b-col>
    </b-row>
    <b-row class="hidenBackground">
      <b-col cols="3">
        <Info label="Número do pedido" :value="uuid" :icon="'fas fa-list-ol'" />
      </b-col>
      <b-col cols="4">
        <Info
          label="Valor total pedido"
          :value="formatNumber(fields.totalValue)"
          :icon="'fas fa-file-invoice-dollar'"
        />
      </b-col>
      <b-col cols="5">
        <Info
          label="Valor do frete"
          :value="formatNumber(fields.shipping)"
          :icon="'fas fa-truck'"
        />
      </b-col>
      <b-col cols="3" class="mt-2 mb-2">
        <Info
          label="Tipo de pagamento"
          :value="getPaymentTypeText(fields.paymentType)"
          :icon="'fas fa-cash-register'"
        />
      </b-col>
      <b-col cols="6" class="mt-2 mb-2">
        <Info
          label="Data do pagamento"
          :value="fields.paidAt"
          :icon="'fas fa-calendar-alt'"
        />
      </b-col>
      <b-col cols="12 mt-2" v-if="fields.paymentDelivery != ''">
        <Info
          label="Tipo de entrega"
          :value="tipoEntrega(fields.paymentDelivery)"
          :icon="'fas fa-exclamation'"
        />
        <strong>Endereço: </strong>{{ fields.paymentAddress }}
      </b-col>
      <b-col
        cols="6 mt-2"
        v-if="
          fields.paymentDelivery == 'delivery' && fields.paymentAddress != ''
        "
      >
        <Info
          label="Endereço de entrega"
          :value="fields.paymentAddress"
          :icon="'fas fa-map-marker-alt'"
        />
      </b-col>
      <b-col
        cols="12 mt-2"
        v-if="fields.paymentExtra != '' && fields.paymentExtra != null"
      >
        <Info
          :label="
            fields.paymentType == 'credit_card'
              ? 'Quantidade de parcela(s)'
              : 'Extras'
          "
          :value="fields.paymentExtra"
        />
      </b-col>
      <b-col cols="12" class="mt-5 text-center">
        <hr />
        <span class="font-weight-bold fs-18">Produtos</span>
      </b-col>
      <b-col cols="12" class="mt-2">
        <b-table-simple hover small responsive>
          <b-thead>
            <b-tr variant="primary" class="border-0">
              <b-th class="text-center"></b-th>
              <b-th>Nome</b-th>
              <b-th class="text-center">Cód. Int.</b-th>
              <b-th class="text-center">Preço</b-th>
              <b-th class="text-center">Quantidade</b-th>
              <b-th class="text-center">Total produto</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(product, index) in fields.products" :key="index">
              <b-td class="text-center">
                <div>
                  <b-img
                    :src="linkImage(product.image)"
                    width="60"
                    height="50"
                    :alt="product.image"
                  ></b-img>
                </div>
              </b-td>
              <b-td>{{ product.name }}</b-td>
              <b-td class="text-center">{{
                product.codInt ? product.codInt : '-'
              }}</b-td>
              <b-td class="text-center">{{ product.quantity }}</b-td>
              <b-td class="text-center">{{
                formatNumber(product.totalPrice)
              }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
      <b-col cols="12" class="mt-5 text-center">
        <span class="font-weight-bold fs-18"
          >Resumo de taxas e recebimento</span
        >
      </b-col>
      <b-col cols="12" class="mt-2">
        <b-table-simple hover small responsive>
          <b-thead>
            <b-tr variant="primary" class="border-0">
              <b-th>Valor total pedido</b-th>
              <b-th>Frete</b-th>
              <b-th>Taxa transação</b-th>
              <b-th>Valor a receber</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-td>{{ formatNumber(fields.totalValue) }}</b-td>
              <b-td>
                <span v-if="fields.shipping">{{
                  formatNumber(fields.shipping)
                }}</span>
                <div
                  v-if="(fields.shippingInfo || {}).picture"
                  :title="`A entrega será realizada por: ${
                    (fields.shippingInfo || {}).name
                  }`"
                >
                  <b-img
                    :src="fields.shippingInfo.picture"
                    width="100px"
                    fluid
                  ></b-img>
                </div>
                <span v-if="fields.shipping == '' || fields.shipping == null">
                  R$ 0,00
                </span>
              </b-td>
              <b-td> {{ formatNumber(taxPayment) }}</b-td>
              <b-td> {{ formatNumber(valueReceivable) }}</b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </b-col>
      <b-col cols="12" class="mt-4 mb-4 text-center">
        <hr />
        <span class="font-weight-bold fs-18">Dados do cliente</span>
      </b-col>
      <b-col cols="4">
        <Info
          label="Nome do cliente"
          :value="fields.client.name"
          :icon="'fas fa-file-signature'"
        />
      </b-col>
      <b-col cols="">
        <Info
          label="E-mail"
          :value="fields.client.email"
          :icon="'fas fa-envelope-open-text'"
        />
      </b-col>
      <b-col cols="">
        <p class="font-weight-bold">
          <i class="fas fa-mobile mr-2 c-orange fs-18"></i> Celular
        </p>
        <p v-html="maskCell(fields.client.cellphone)"></p>
      </b-col>
      <b-col cols="4" class="mt-4" v-if="fields.client.cnpj == ''">
        <Info label="RG" :value="fields.client.rg" :icon="'fas fa-id-card'" />
      </b-col>
      <b-col cols="4" class="mt-4" v-if="fields.client.cnpj == ''">
        <Info label="CPF" :value="fields.client.cpf" :icon="'fas fa-user'" />
      </b-col>
      <b-col cols="8" class="mt-4" v-if="fields.client.cnpj != ''">
        <Info
          label="CNPJ"
          :value="fields.client.cnpj"
          :icon="'fas fa-building'"
        />
      </b-col>
      <b-col cols="4" class="mt-4">
        <Info
          label="Criado em"
          :value="fields.client.createdAt"
          :icon="'fas fa-calendar'"
        />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="4" class="mt-4">
        <Info label="Quem mais Recebe/Retira" :value="fields.withdraw" />
      </b-col>
      <b-col cols="4" class="mt-4">
        <Info label="Recebido/Entregue para" :value="fields.received" />
      </b-col>
      <b-col cols="4" class="mt-4">
        <Info label="Vendedor" :value="fields.clerk ? fields.clerk : ''" />
      </b-col>
    </b-row>
    <b-row v-if="dataShopkeeper" class="mt-5">
      <b-col cols="12" class="mt-4 mb-4 text-center">
        <span class="font-weight-bold fs-18">Dados do Lojista</span>
      </b-col>
      <b-col cols="4">
        <Info label="Id" :value="dataShopkeeper.userId" />
      </b-col>
      <b-col cols="4">
        <Info label="Nome do lojista" :value="dataShopkeeper.nome_fantasia" />
      </b-col>
      <b-col cols="4">
        <Info label="CNPJ" :value="dataShopkeeper.cnpj" />
      </b-col>
      <b-col cols="4" class="mt-4">
        <Info label="Celular" :value="dataShopkeeper.celular" />
      </b-col>
      <b-col cols="4" class="mt-4">
        <Info label="E-mail" :value="dataShopkeeper.email" />
      </b-col>
      <b-col cols="8" class="mt-4">
        <Info label="Endereço" :value="addresShopkeeper()" />
      </b-col>
      <b-col cols="4" class="mt-4" v-if="dataShopkeeper.complemento">
        <Info label="Complemento" :value="dataShopkeeper.complemento" />
      </b-col>
    </b-row>
    <hr />
  </div>
</template>

<script>
import { formatNumber } from '@/utils';
import SelectProducts from '@/views/lojista/products/SelectProducts.vue';
import makeToast from '@/mixins/makeToast';
import { mapState } from 'vuex';
import Info from '@/components/Inputs/Info.vue';

export default {
  name: 'OrderDetailsPrint',
  mixins: [makeToast],
  props: {
    shopkeepersIds: Array,
  },
  data() {
    return {
      loading: false,
      orderId: 0,
      uuid: 0,
      open: false,
      fields: this.defaultOrderDetails(),
      taxPayment: 0,
      valueReceivable: 0,
      dataShopkeeper: null,
    };
  },

  computed: {
    ...mapState(['dadosUsuario']),
  },

  mounted() {
    this.get();
  },

  methods: {
    formatNumber,

    get() {
      this.dataShopkeeper = JSON.parse(
        localStorage.getItem('dadosLojistaPrint')
      );
      this.fields = JSON.parse(localStorage.getItem('dadosOrdemPrint'));
      localStorage.removeItem('dadosLojistaPrint');
      localStorage.removeItem('dadosOrdemPrint');
      this.orderId = this.$route.query.order;
      this.uuid = this.$route.query.uuid;
      this.taxView();
      this.impressOrder();
    },

    linkImage(value) {
      return process.env.VUE_APP_FOTOS_URL + value;
    },

    impressOrder() {
      let footer = document.getElementsByClassName('footer');
      let header = document.getElementsByClassName('header');

      if (header.length > 0) {
        header[0].setAttribute('class', 'hidenBackground');
      }

      if (footer.length > 0) {
        footer[0].setAttribute('id', 'noPrint');
        footer[0].setAttribute('class', 'hidenBackground');
      }

      document.title = 'Ordem: ' + this.$route.query.uuid;
      window.print();
      window.onafterprint = () => {
        window.close();
      };
    },

    tipoEntrega(tipo) {
      if (tipo == 'delivery') {
        return 'Entrega no endereço do cliente';
      } else if (tipo == 'motorcycle') {
        return 'Motoboy';
      } else {
        return 'Retirada em loja';
      }
    },

    maskCell(value) {
      if (!value) return '';
      value = value.replace(/\D/g, '');
      value = value.replace(/(\d{2})(\d)/, '($1) $2');
      value = value.replace(/(\d)(\d{4})$/, '$1-$2');
      return value;
    },
    defaultOrderDetails() {
      return {
        totalValue: '',
        shipping: '',
        paymentType: '',
        client: '',
        received: '',
        withdraw: '',
        products: [],
      };
    },
    getPaymentTypeText(type) {
      const texts = {
        credit_card: 'Cartão de crédito',
        pix: 'Pix',
        all: 'Boleto',
        wallet: 'Carteira',
      };
      return texts[type] || 'N/A';
    },
    taxView() {
      if (this.fields.paymentType == 'all') {
        this.taxPayment = 1.89;
      } else if (this.fields.paymentType == 'pix') {
        this.taxPayment = 0.5;
      } else if (this.fields.paymentType == 'credit_card') {
        this.taxPayment = this.fields.totalValue * 0.0235 + 0.3;
      } else {
        this.taxPayment = 0;
      }
      this.valueReceivable = this.fields.totalValue - this.taxPayment;
    },
    addresShopkeeper() {
      const address =
        this.dataShopkeeper.endereco +
        ', ' +
        this.dataShopkeeper.numero +
        ' - ' +
        this.dataShopkeeper.bairro +
        ' - ' +
        this.dataShopkeeper.cidade +
        '/' +
        this.dataShopkeeper.Estado;
      return address;
    },
  },
  components: {
    Info,
    SelectProducts,
  },
};
</script>
<style>
.informations {
  margin-right: 180px;
}
.hidenBackground {
  visibility: hidden;
}

@media print {
  body * {
    visibility: hidden;
    background-color: white;
  }
  #printable,
  #printable * {
    visibility: visible;
  }
  #printable {
    position: fixed;
    left: 20px;
    top: 30px;
    bottom: 0;
  }
  .noPrint {
    display: none;
  }
}
</style>
